onDomReady(() => {
   when($('blurbsWidget'), div => {
      new BlurbsWidget(div);
   });
});

const BlurbsWidget = new Class({
   Implements: [Options],

   active: true,
   index: 0,
   options: {
      autoscroll: true,
   },

   initialize: function (container, options) {
      this.setOptions(options);

      this.container = $(container);
      this.navThumbs = this.container.getElements('.blurbNavThumbs');

      this.navThumbs.each(el => {
         el.addEvent('mouseenter', ev => {
            this.activate(el);
         });
      });

      if (this.options.autoscroll && this.navThumbs.length) {
         this.container.addEvents({
            mouseenter: this.pause.bind(this),
            mouseleave: this.resume.bind(this),
         });

         this.rotate.periodical(6000, this);
      }
   },

   rotate: function () {
      if (!this.active) {
         return;
      }

      if (++this.index >= this.navThumbs.length) {
         this.index = 0;
      }

      this.activate(this.navThumbs[this.index]);
   },

   pause: function () {
      this.active = false;
   },

   resume: function () {
      this.active = true;
   },

   activate: function (el) {
      let index = el.get('id').split('_', 2)[1];

      this.container.getElements('.selectedBlurb').each(blurb => {
         if (blurb.get('id').split('_', 2)[1] == index) {
            blurb.removeClass('blurbHidden');
         } else {
            blurb.addClass('blurbHidden');
         }
      });

      // Remove border, add shading to inactives
      this.navThumbs.each(blurb => {
         blurb.getElement('a').removeClass('active');
      });

      // Add border, remove shading to the active element
      el.getElement('a').addClass('active');
   },
});
